/* eslint-disable */
import { CardContent, Grid, RACButton, Typography, Card, CircularProgress, RACModalCard } from "@rentacenter/racstrap";
import { ReactComponent as RACFilter } from "../../../assets/images/filter-white.svg";
import { ReactComponent as AccordianOpen } from "../../../assets/images/up-arrow-filter.svg";
import { ReactComponent as AccordianClose } from "../../../assets/images/down-arrow-filter.svg";
import { CostBasedPricingStyles } from "../Styles/CostBasedPricing";
import CostBasedPricingFilter from "./CostBasedPricingFilter";
import { useContext, useEffect, useState } from "react";
import { accessFeature, getEmployeeInfoAndReferenceData } from "../../shared/getEmployeeInfoAndReferenceData";
import { ContainerContext } from "../../../app/App";
import { CustomPropInterface } from "../../..";
import updatePricingQueueStatusAPI, { fetchDropDownAPI } from "../../../api/user";
import { CostBasedPricingContext } from "./CostBasedPricingContext";
import { mapDropDownData } from "../../../utils/utils";
import CostBasedPricingGrid from "./CostBasedPricingGrid";
import CostBasedPricingForm from "./CostBasedPricingForm";
import { ReactComponent as WarningIcon } from "../../../assets/images/no-records-found.svg";
import { ReactComponent as Danger } from "../../../assets/images/danger.svg";
import { ReactComponent as SuccessIcon } from "../../../assets/images/success-icon.svg";
import TwoFactorAuthentication from "../../shared/TwoStepAuthentication";

export default function CostBasedPricing() {
    const containerData = useContext(ContainerContext) as CustomPropInterface;
    const classes = CostBasedPricingStyles();
    const { setDeptOptions, loader, setLoader, setDropDownData, displayGrid, setDisplayGrid, pageDisplay, displayForm, setDisplayForm,
        formProps, setFormProps, setCostBasedPricingFormData, handlePopup, setHandlePopup, userInfo, setUserInfo,
        pricingQueueId, setErrorMessage, errorMessage, setDeptFormOptions
    } = useContext(CostBasedPricingContext);
    const [authOpen, setAuthOpen] = useState(false);
    const [approvedBy, setApprovedBy] = useState('');
    const [isSLACompleted, setIsSLACompleted] = useState(false);
    const [isSLACancel, setIsSLACancel] = useState(false);
    const [isApproved, setIsApproved] = useState(false)

    useEffect(() => {
        getMenuandDropdownData();
    }, []);

    const getMenuandDropdownData = async () => {
        let req: any = {
            type: [
                "DEPARTMENT",
                "SUBDEPARTMENT",
                "BRACKET"
            ]
        }
        setLoader({ ...loader, dropdownLoader: true })
        const response = await Promise.all([
            getEmployeeInfoAndReferenceData(containerData, {}, true),
            fetchDropDownAPI(req),
            getEmployeeInfoAndReferenceData(containerData, {}, false, true)
        ]);
        setLoader({ ...loader, dropdownLoader: false })
        let menuConfig;
        let dropdownData;
        let userDetails;
        if (response?.length) {
            menuConfig = response[0];
            if (response[1]?.status == 200 && response[1]?.data) {
                dropdownData = response[1]?.data;
                setDropDownData(dropdownData)
            }
            userDetails = response[2];
        }
        if (dropdownData?.department) {
            const deptData = await mapDropDownData(dropdownData.department, "descEn", "departmentNumber");
            setDeptOptions(deptData);
            setDeptFormOptions(deptData)
        }
        const hasApproveAccess = accessFeature(menuConfig, 'Cost Based Pricing', 'approve')
        const hasEditAccess = accessFeature(menuConfig, 'Cost Based Pricing', 'edit')
        console.log(userDetails, 'hasApproveAccesshasApproveAccess')
        setUserInfo({
            ...userInfo, hasApproveAccess: hasApproveAccess, hasEditAccess: hasEditAccess, emailId: userDetails.email, employeeId: userDetails.employeeId, userName: userDetails.userName
        })
    };
    console.log(userInfo, 'userInfouserInfouserInfo')

    useEffect(() => {
        if (isSLACancel == false && isSLACompleted == true) {
            setHandlePopup({ ...handlePopup, isOpen: false })
            setAuthOpen(false);
            updatePricingQueueStatus('A');
        }
    }, [isSLACancel, isSLACompleted]);

    const updatePricingQueueStatus = async (params: string) => {
        try {
            setLoader({ ...loader, mainPage: true });
            let req = {
                pricingQueueId: pricingQueueId?.toString(),
                status: params,
                actionBy: approvedBy,
            };
            const response = await updatePricingQueueStatusAPI(req);
            if (response.status == 200) {
                setLoader({ ...loader, mainPage: false });
                setAuthOpen(false);
                setIsApproved(true);
            } else {
                setHandlePopup({ isOpen: true, Content: 'Something went wrong', index: 0, type: 'error' });
                setLoader({ ...loader, mainPage: false });
            }
        } catch (e) {
            setHandlePopup({ isOpen: true, Content: 'Something went wrong', index: 0, type: 'error' });
            setLoader({ ...loader, mainPage: false });
        }
    };

    const popUp = () => {
        return (
            <>
                <Grid>
                    <Grid style={{ justifyContent: "center", display: "flex" }}>
                        {handlePopup.type == 'success' ?
                            <SuccessIcon width={"10%"} height={"10%"} />
                            : handlePopup.type == 'error' ?
                                <WarningIcon width={"10%"} height={"10%"} />
                                : <Danger width={"10%"} height={"10%"} />}
                    </Grid>
                    <Grid>
                        <Typography variant="h5" style={{ textAlign: "center", padding: '2% 0%' }} >
                            {handlePopup.Content}
                        </Typography>
                        {handlePopup.type == 'success' ? <Typography variant="h5" style={{ textAlign: "center" }}>
                            Do you want to continue for approval?
                        </Typography> : null}
                    </Grid>
                    {handlePopup.type == 'success' ?
                        <Grid
                            style={{ display: "flex", justifyContent: "center", margin: "5%" }}
                        >
                            <RACButton
                                style={{ marginRight: "10%" }}
                                variant="outlined"
                                onClick={() => setHandlePopup({ ...handlePopup, isOpen: false })}
                            >
                                No
                            </RACButton>
                            <RACButton
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setHandlePopup({ ...handlePopup, isOpen: false })
                                    setAuthOpen(true);
                                }}
                            >
                                Yes
                            </RACButton>
                        </Grid>
                        : handlePopup.type == 'error' ?
                            <Grid
                                style={{ justifyContent: "center", display: "flex", marginTop: '5%' }}>
                                <RACButton
                                    onClick={() => setHandlePopup({ ...handlePopup, isOpen: false })}
                                    color="primary"
                                    variant="contained"
                                >
                                    OK
                                </RACButton>
                            </Grid> : null
                    }
                </Grid>
            </>
        );
    };

    const approvedFn = () => {
        return (
            <>
                <Grid>
                    <Grid style={{ justifyContent: "center", display: "flex" }}>
                        <SuccessIcon width={"10%"} height={"10%"} />
                    </Grid>
                    <Grid>
                        <Typography variant="h5" style={{ textAlign: "center", padding: "5%" }} >
                            Request has been approved.
                        </Typography>
                    </Grid>
                    <Grid style={{ justifyContent: "center", display: "flex" }} >
                        <RACButton
                            onClick={() => {
                                setIsApproved(false);
                                setIsSLACompleted(false);
                                setIsSLACancel(false);
                            }}
                            color="primary"
                            variant="contained"
                        >
                            OK
                        </RACButton>
                    </Grid>
                </Grid>
            </>
        );
    }

    return (
        <>
            {loader.mainPage ? (
                <Grid className={classes.masterLoader}>
                    <Grid className={classes.Loader}>
                        <CircularProgress />
                    </Grid>
                </Grid>
            ) : null}
            {displayForm ? <CostBasedPricingForm formData={formProps} /> :
                <Grid container md={12} className={`${classes.pagePadding1}`}>
                    <Grid container md={12} className={`${classes.mb15}`}>
                        <Grid item md={6}>
                            <Typography className={`${classes.floatLeft} ${classes.title4}`}>Cost Based Pricing Details</Typography>
                        </Grid>
                        <Grid item md={6}>
                            <RACButton
                                color="primary"
                                variant="contained"
                                size="small"
                                className={`${classes.floatRight}`}
                                onClick={() => {
                                    if (pageDisplay != 0) {
                                        setDisplayGrid(!displayGrid)
                                    }
                                }}
                            >
                                <RACFilter />
                                <span style={{ margin: "0px 8px" }}>Filter</span>
                                {!displayGrid ? <AccordianOpen /> : <AccordianClose />}
                            </RACButton>
                        </Grid>
                    </Grid>
                    {!displayGrid ? <CostBasedPricingFilter /> : null}
                    {(pageDisplay != 0 || loader.contentLoader) ? <CostBasedPricingGrid /> : null}
                    <Card style={{ position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0" }}>
                        <CardContent style={{ padding: '5px 10px 10px 0px' }}>
                            <Grid md={12} lg={12} sm={12} xs={12} spacing={3}>
                                <RACButton
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    style={{ float: "right", margin: '10px' }}
                                    loading={loader.dropdownLoader}
                                    disabled={loader.dropdownLoader}
                                    onClick={() => {
                                        if (userInfo.hasEditAccess) {
                                            setDisplayForm(true)
                                            setDisplayGrid(false)
                                            setFormProps(undefined)
                                            setCostBasedPricingFormData({
                                                zone: '2000',
                                                department: '',
                                                subdepartment: '',
                                                bracket: '',
                                                startDate: '',
                                                endDate: '2099-12-31',
                                                publishPriceForExisitingRMS: '',
                                                publishPriceWhenCostChanges: '',
                                                schedule: '',
                                                minRatePct: '',
                                                maxRatePct: '',
                                                minRateNew: '',
                                                maxRateNew: '',
                                                minRateUsed: '',
                                                maxRateUsed: '',
                                                turns: '',
                                                termMax: '',
                                                initialAmount: '',
                                                growth: '',
                                                lineShiftLr: '',
                                                lineShiftUd: '',
                                                usedRateAdjustment: ''
                                            })
                                            setErrorMessage({
                                                ...errorMessage,
                                                startDate: '',
                                                endDate: '',
                                                minRatePct: '',
                                                maxRatePct: '',
                                                minRateNew: '',
                                                maxRateNew: '',
                                                minRateUsed: '',
                                                maxRateUsed: '',
                                                termMax: ''
                                            })
                                        } else {
                                            setHandlePopup({ isOpen: true, Content: 'This feature is currently restricted to this User', index: 0, type: 'error' });
                                        }
                                    }}
                                >
                                    New Cost Based Pricing
                                </RACButton>

                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>}
            <RACModalCard
                isOpen={handlePopup.isOpen}
                maxWidth="xs"
                borderRadius={10}
                closeIcon={true}
                onClose={() => setHandlePopup({ ...handlePopup, isOpen: false })}
            >
                {popUp()}
            </RACModalCard>
            <TwoFactorAuthentication
                IsHigherAuthority={userInfo.hasApproveAccess} isVisible={authOpen} setIsVisible={setAuthOpen} loader={loader.mainPage} setloader={(e: Boolean) => {
                    setLoader({ ...loader, mainPage: e })
                }} setTwoFactorCompleted={setIsSLACompleted} setTwoFactorCancelClick={setIsSLACancel} twoFactorCompleted={isSLACompleted} twoFactorCancelClick={isSLACancel} setSomethingWentWrong={(e: any) => {
                    setHandlePopup({ isOpen: e, Content: 'Something went Wrong', index: 0, type: 'error' });
                }} mailId={userInfo.emailId} employeeId={userInfo.employeeId} submitedBy={userInfo.userName} ApprovedBy={setApprovedBy} 
                moduleName = {'Cost Based Pricing'} accessPrivilage = {'approve'}/>
            <RACModalCard
                isOpen={isApproved}
                maxWidth="xs"
                borderRadius={10}
                closeIcon={true}
                onClose={() => {
                    setIsSLACompleted(false);
                    setIsSLACancel(false);
                    setIsApproved(false)
                }}
            >
                {approvedFn()}
            </RACModalCard>
        </>
    )
}